var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerSvg"},[_c('div',{staticClass:"svgWrap"},[_c('img',{staticClass:"hulanSvg",attrs:{"src":require("./svg/hulan.svg"),"alt":""}}),_c('img',{class:['liftSvg', _vm.animationName],attrs:{"src":require("./svg/lift.svg"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }